import { isCustomEvent } from '../../Settings'
import { CampaignEventType } from '@/api/dashboard'
import i18next from 'i18next'

export default function getCampaignName(type: CampaignEventType | string) {
  const isCustom = isCustomEvent(type)

  return isCustom ? type : i18next.t(`campaign.type.${type}`)
}
